import { forwardRef } from "react";

const GhostLink = forwardRef(function GhostLink(
    { children, className = "", as: Tag = "a", ...rest },
    ref
) {
    return (
        <Tag
            ref={ref}
            className={`
                group inline-flex items-center gap-2
                font-mono-tight uppercase tracking-[0.22em] text-xs
                text-tca-ink-muted hover:text-tca-cyan-hi
                transition-colors duration-300
                ${className}
            `}
            {...rest}
        >
            <span className="relative">
                {children}
                <span
                    aria-hidden="true"
                    className="absolute -bottom-[3px] left-0 w-0 h-px bg-tca-cyan group-hover:w-full transition-all duration-500 ease-out"
                />
            </span>
            <span
                aria-hidden="true"
                className="inline-block transition-transform duration-300 group-hover:translate-x-1"
            >
                →
            </span>
        </Tag>
    );
});

export default GhostLink;
